import React from 'react';
import { Table, Row, Popconfirm } from 'antd';
import PropTypes from 'prop-types';
import { Tick as TickIcon, TickNo } from 'common/components/svgs';

export default class DepositTable extends React.Component {
  getColumns = () => {
    const { t, isView } = this.props;
    const columnNum = isView ? 4 : 5;
    const columns = [
      {
        title: t('landlord.payment.long_tail.deposit_name.field'),
        dataIndex: 'name',
        key: 'name',
        width: `${100 / columnNum}%`,
      },
      {
        title: t('landlord.payment.long_tail.amount_gbp.field', {
          currency: this.props.currency,
        }),
        dataIndex: 'amount',
        width: `${100 / columnNum}%`,
        key: 'amount',
      },
      {
        title: t('landlord.payment.long_tail.deposit_type.field'),
        dataIndex: 'paymentType',
        key: 'paymentType',
        width: `${100 / columnNum}%`,
        render: text => (
          <If condition={text}>
            <span> {t(`landlord.payment.deposit.despoit_type.${text.toLowerCase()}`)} </span>
          </If>
        ),
      },

      {
        title: t('landlord.payment.long_tail.rent_payment.table.pay_now_to_student'),
        dataIndex: 'payThroughStcom',
        key: 'payThroughStcom',
        width: `${100 / columnNum}%`,
        render: text => {
          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <If condition={text}>
                <TickIcon className="long-tail__icon-tick" />
                {t('landlord.payment.long_tail.button.yes')}
              </If>
              <If condition={!text}>
                <TickNo className="long-tail__icon-no" />
                {t('landlord.payment.long_tail.button.no')}
              </If>
            </div>
          );
        },
      },
    ];

    if (!isView) {
      columns.push({
        title: t('landlord.payment.long_tail.action.field'),
        key: 'action',
        width: `18%`,
        render: (text, record) => {
          return (
            <Row>
              <button
                className="long-tail__deposit__table-btn"
                onClick={() => {
                  this.props.onEdit(record);
                }}
              >
                {t('landlord.payment.long_tail.button.edit')}
              </button>
              <If condition={!(this.props?.isMustPayDespositFee && !!record?.cannotDelete)}>
                <Popconfirm
                  placement="topRight"
                  title={t('landlord.payment.long_tail.delete_instalment_plan.title', {
                    name: record.name,
                  })}
                  onConfirm={() => {
                    this.props.onDelete(record);
                  }}
                  okText={t('landlord.payment.long_tail.button.yes')}
                  overlayStyle={{
                    maxWidth: '300px',
                  }}
                  okType="danger"
                  cancelText={t('landlord.payment.long_tail.button.no')}
                >
                  <button className="long-tail__deposit__table-btn">
                    {' '}
                    {t('landlord.payment.long_tail.button.delete')}{' '}
                  </button>
                </Popconfirm>
              </If>
            </Row>
          );
        },
      });
    }

    return columns;
  };

  render() {
    return (
      <div>
        <Table
          className="long-tail__table long-tail__table--deposit"
          columns={this.getColumns()}
          rowKey={record => record.id}
          dataSource={this.props.dataSource}
          pagination={false}
        />
      </div>
    );
  }
}

DepositTable.propTypes = {
  t: PropTypes.func.isRequired,
  isView: PropTypes.bool,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  dataSource: PropTypes.array,
  currency: PropTypes.string,
  isMustPayDespositFee: PropTypes.bool,
};
DepositTable.defaultProps = {
  t: () => {},
  isView: false,
  dataSource: [],
  onDelete: () => {},
  onEdit: () => {},
  currency: '',
  isMustPayDespositFee: false,
};
